import styled from 'styled-components';

const LinkGeneratedContainer = styled.div`
  margin: 10px 30px;
`;
const Title = styled.div`
  font-size: 27px;
  font-weight: 900;
`;
const Description = styled.div`
  font-size: 21px;
  margin-top: 10px;
  font-weight: normal;
  color: #866111;
`;
const Text = styled.div`
  font-size: 21px;
  margin-top: 10px;
  font-weight: normal;
  color: #008f69;
`;
const Label = styled.div`
  margin-top: 10px;
  min-width: 200px;
  font-size: 17px;
  font-weight: 900;
`;
const Link = styled.a`
  text-decoration: underline;
  font-size: 23px;
  font-weight: normal;
  color: #3b5de0;
  cursor: pointer;
`;
const Create = styled.div`
  text-decoration: underline;
  font-size: 23px;
  font-weight: normal;
  margin-top: 20px;
  color: #3b5de0;
  cursor: pointer;
`;
export default {
  LinkGeneratedContainer,
  Title,
  Text,
  Description,
  Label,
  Link,
  Create
};



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/LinkGenerated/styles.js